import { configureStore } from '@reduxjs/toolkit';
import { creatorListenerMiddleware } from './middlewares/creatorMiddlewares';
import { initCreatorListeners } from './listeners';
import { loadCartStateFromLocalStorage } from '@/utils/utilities';
import { StoreKey } from '@/configs/storeKeys';
import creatorReducer from './slices/creatorSlice';
import cartReducer from './slices/cartSlice';
import appReducer from './slices/appSlice';

export const store = configureStore({
	reducer: {
		[StoreKey.APP]: appReducer,
		[StoreKey.CREATOR]: creatorReducer,
		[StoreKey.CART]: cartReducer,
	},
	devTools: import.meta.env.DEV,
	preloadedState: {
		[StoreKey.CART]: loadCartStateFromLocalStorage(),
	},
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware().prepend(creatorListenerMiddleware.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

initCreatorListeners(store);
